import { jsx as _jsx } from "react/jsx-runtime";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
export var BackInStockToast = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "nnwDjA",
        defaultMessage: [
            {
                type: 0,
                value: "We\u2019ll notify you via email when the product is back in stock."
            }
        ]
    });
};
